module.exports = __webpack_public_path__ + "static/media/milgro.4529ee9e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/milgro.webp
// module id = 271
// module chunks = 0